module.exports = __webpack_public_path__ + "img/pic_zy_mr_s.c15aa6d9.png";